module.exports = __webpack_public_path__ + "img/ring_y_skip_null_null.bf88aa72.png";